import { SportPositionPicker } from "@/components/games/SportPositionPicker";
import { getSportPositionsForSport } from "@/utils/sport-positions";

type GamePreferredPositionSelectProps = {
  sport?: string | null;
  sportCategory?: string | null;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  size?: "sm" | "default";
  compact?: boolean;
  className?: string;
  disabled?: boolean;
};

export function GamePreferredPositionSelect({
  sport,
  sportCategory,
  value,
  onChange,
  label = "Posição pretendida",
  size = "sm",
  compact = false,
  className,
  disabled,
}: GamePreferredPositionSelectProps) {
  const positions = getSportPositionsForSport(sport, sportCategory);
  if (positions.length === 0) return null;

  return (
    <SportPositionPicker
      sport={sport}
      sportCategory={sportCategory}
      value={value}
      onChange={onChange}
      label={label}
      size={size}
      compact={compact}
      className={className}
      disabled={disabled}
    />
  );
}
